module.exports = __webpack_public_path__ + "media/images/homes/Whatwillmyguestssee-e870e9de4e2796808b526dc50f6b218a.png";